import { Component, OnInit } from '@angular/core';
import { SurveyService } from 'src/app/shared/services/survey.service';

@Component({
  selector: 'app-survey-layout',
  templateUrl: './survey-layout.component.html',
  styleUrls: ['./survey-layout.component.scss']
})
export class SurveyLayoutComponent implements OnInit {
  isMaintenance: boolean = false;
  maintenanceStartTime = new Date('2025-06-16T07:00:00+08:00'); //指定為台灣時間
  maintenanceEndTime = new Date('2025-06-16T08:00:00+08:00');
  maintenanceEndTimeFormatted: string = '08:00';
  
  constructor(
    private surveyService: SurveyService, 
  ) { }

  ngOnInit(): void {
    // 定義系統維護時間段（2025/06/16 7:00 AM ~ 8:00 AM）
    if (this.surveyService.openSurveyDuringMaintenance(this.maintenanceStartTime,this.maintenanceEndTime)) {
      console.log("系統維護中...",this.maintenanceStartTime,"-",this.maintenanceEndTime)
      this.isMaintenance = true;
    }
  }

}
